import * as Phaser from "phaser-ce"
import { COLOR } from "../../../common/Color"
import { Align } from "../../../common/TextUtils"
import { ActivityKey } from "../../../shared/models/ActivityKey"
import { Buttons } from "../../generic-sprites/Buttons"
import { loadGenericAssets } from "../../generic-sprites/GenericAssets"
import { colorNum, ColorUtils } from "../../utils/ColorUtils"
import { PhaserText } from "../../utils/PhaserText"
import { PhaserUtils } from "../../utils/PhaserUtils"
import { Scale } from "../../utils/Scale"
import { Sprites } from "../../utils/Sprites"
import { Videos } from "../../utils/Videos"
import { Transitions } from "../transitions/Transitions"
import { loadAssets, summaryData } from "./SummaryAssets"

export class SummaryState extends Phaser.State {
    preload() {
        loadGenericAssets(this.game)
        loadAssets(this.game)
    }

    async create() {
        await PhaserUtils.sharedCreateFunctions(this.game)
        ColorUtils.setBackgroundColorBlack(this.game)

        this.makeScene()
    }

    makeScene = () => {
        const group = this.game.add.group()
        let playCount = 0

        let x = 0
        let y = Scale.y(0.1)

        summaryData.forEach((item, i) => {
            const thumbnail = Sprites.add(this.game, item.thumbnail, {
                x,
                y,
                group,
            })
            Buttons.makeSpriteButton(thumbnail, async () => {
                group.visible = false
                const setVideoWatched = () => {
                    group.visible = true
                    thumbnail.tint = colorNum.gray
                    thumbnail.inputEnabled = false
                    if (video) {
                        video.destroy()
                    }
                    playCount++
                    if (playCount >= 5) {
                        nextButton.enable()
                    }
                }

                const video = await Videos.add(this.game, item.video, {
                    fillScreen: true,
                    onComplete: setVideoWatched,
                    onException: setVideoWatched,
                })
            })
            Scale.scaleToFitHorizontal(thumbnail, 3)
            x += thumbnail.width

            const label = PhaserText.create(this.game, item.label, {
                y: thumbnail.y + thumbnail.height,
                color: COLOR.white,
                fontPx: 14,
                align: Align.CENTER,
                group,
            })
            label.x = Sprites.centerCoorForSpriteInSprite(
                thumbnail.x,
                thumbnail.width,
                label.width,
            )

            // padding
            const preScaleWidth = thumbnail.width
            const preScaleHeight = thumbnail.height
            thumbnail.scale.subtract(0.02, 0.02)
            thumbnail.x += (preScaleWidth - thumbnail.width) / 2
            thumbnail.y += (preScaleHeight - thumbnail.height) / 2

            // reset to begin second row
            if (i === 2) {
                x = Scale.availableWidth() / 6
                y = Scale.availableHeight() - preScaleHeight - label.height
            }
        })

        PhaserText.create(
            this.game,
            "Click on each of the video icons to see a quick review of all the activities.",
            {
                centerInWorldXOnly: true,
                align: Align.CENTER,
                color: COLOR.white,
                wordWrapWidth: Scale.availableWidth() / 1.5,
                y: Scale.availableHeight() / 2,
                group,
            },
        )

        const nextButton = Buttons.create(
            this.game,
            "Next",
            () => {
                group.destroy(true)
                Transitions.startOutro(this.game, ActivityKey.SUMMARY)
            },
            { x: Scale.x(0.84), y: Scale.y(0.95), group },
        )
        nextButton.disable()
    }
}
